export const vaccinationWeekList = [
  {
    name: 'Birth',
    url: 'birth',
  },
  {
    name: '6 Weeks',
    url: '6-weeks',
  },
  {
    name: '10 Weeks',
    url: '10-weeks',
  },
  {
    name: '14 Weeks',
    url: '14-weeks',
  },
  {
    name: '6 Months',
    url: '6-months',
  },
  {
    name: '9 Months',
    url: '9-months',
  },
  {
    name: '9-12 Months',
    url: '9-12-months',
  },
  { name: 'SELECT AGE', url: '' },
  {
    name: '12 Months',
    url: '12-months',
  },
  {
    name: '15 Months',
    url: '15-months',
  },
  {
    name: '15-18 Months',
    url: '15-18-months',
  },
  {
    name: '18 Months',
    url: '18-months',
  },
  {
    name: '2 Years',
    url: '2-years',
  },
  {
    name: '4-6 Years',
    url: '4-6-years',
  },
  {
    name: '10-12 Years',
    url: '10-12-years',
  },
];

export const vaccineDetailData = {
  'birth': [
    {
      vaccName: 'BCG',
      desc: 'Helps in building immunity against, tuberculosis.',
      show: true,
    },
    {
      vaccName: 'OPV 0',
      desc: 'Helps in building immunity against, tuberculosis.',
      show: false,
    },
    {
      vaccName: 'Hepatitis-B',
      desc: 'Develop protection against virus affecting liver',
      show: false,
    },
  ],
  '6-weeks': [
    {
      vaccName: 'IPV 1',
      desc: 'Helps the baby to fight against Polio (causing paralysis).',
      show: true,
    },
    {
      vaccName: 'Hepatitis-B 2',
      desc: 'Protects against virus affecting liver',
      show: false,
    },
    {
      vaccName: 'DTP 1',
      desc: 'Provides the baby with the protection against three diseases – pertussis, diphtheria and tetanus.',
      show: false,
    },
    {
      vaccName: 'Rotavirus 1',
      desc: 'Decreases the risk of death being caused by diarrhoea.',
      show: false,
    },
    {
      vaccName: 'Influenza type B (Hib 1)',
      desc: 'Protects the baby from Hib virus.',
      show: false,
    },
    {
      vaccName: 'PCV 1',
      desc: 'Protects against the pneumococcal infections. Meningitis, pneumonia, and certain serious ear infections can be caused by the bacteria.',
      show: false,
    },
  ],
  '10-weeks': [
    {
      vaccName: 'DTP 2',
      desc: 'Provides the baby with the protection against three diseases – pertussis, diphtheria and tetanus.',
      show: true,
    },
    {
      vaccName: 'IPV 2',
      desc: 'Helps the baby to fight against Polio (causing paralysis).',
      show: false,
    },
    {
      vaccName: 'Influenza type B (Hib 2)',
      desc: 'Protects the baby from Hib virus.',
      show: false,
    },
    {
      vaccName: 'Rotavirus 2',
      desc: 'Decreases the risk of death being caused by diarrhoea.',
      show: false,
    },
    {
      vaccName: 'PCV 2',
      desc: 'Protects against the pneumococcal infections. Meningitis, pneumonia, and certain serious ear infections can be caused by the bacteria.',
      show: false,
    },
  ],
  '14-weeks': [
    {
      vaccName: 'DTP 3',
      desc: 'Provides the baby with the protection against three diseases – pertussis, diphtheria and tetanus.',
      show: true,
    },
    {
      vaccName: 'IPV 3',
      desc: 'Helps the baby to fight against Polio (causing paralysis).',
      show: false,
    },
    {
      vaccName: 'Hib 3',
      desc: 'Protects the baby from Hib virus.',
      show: false,
    },
    {
      vaccName: 'Rotavirus 3',
      desc: 'Decreases the risk of death being caused by diarrhoea.',
      show: false,
    },
    {
      vaccName: 'PCV 3',
      desc: 'Protects against the pneumococcal infections. Meningitis, pneumonia, and certain serious ear infections can be caused by the bacteria.',
      show: false,
    },
  ],
  '6-months': [
    {
      vaccName: 'OPV 1',
      desc: 'Helps the baby to fight against Polio (causing paralysis).',
      show: true,
    },
    {
      vaccName: 'Hep-B 3',
      desc: 'Protects against virus affecting liver',
      show: false,
    },
  ],
  '9-months': [
    {
      vaccName: 'OPV 2',
      desc: 'Helps the baby to fight against Polio (causing paralysis).',
      show: true,
    },
    {
      vaccName: 'MMR 1',
      desc: 'Provides immunity against rubella, measles and mumps.',
      show: false,
    },
  ],
  '9-12-months': [
    {
      vaccName: 'Typhoid Conjugate Vaccine',
      desc: 'Protects the baby from the typhoid fever. The fever from the disease is quite to be serious for, as it generally gets the baby into an acute illness.',
      show: true,
    },
  ],

  '12-months': [
    {
      vaccName: 'Hep-A 1',
      desc: 'Provides protection to the baby from Hepatitis A disease.',
      show: true,
    },
  ],
  '15-months': [
    {
      vaccName: 'MMR',
      desc: 'Provides immunity against rubella, measles and mumps.',
      show: true,
    },
    {
      vaccName: 'Varicella',
      desc: 'A.k.a chickenpox vaccine, and protects against the same. 1 dose prevents about 95% of the moderate diseases and 100% of the severe ones.',
      show: false,
    },
    {
      vaccName: 'PCV Booster',
      desc: 'Protects against the pneumococcal infections. Meningitis, pneumonia, and certain serious ear infections can be caused by the bacteria.',
      show: false,
    },
  ],
  '15-18-months': [
    {
      vaccName: 'DTP B1',
      desc: 'Provides the baby with the protection against three diseases – pertussis, diphtheria and tetanus.',
      show: true,
    },
    {
      vaccName: 'IPV B1',
      desc: 'Helps the baby to fight against Polio (causing paralysis).',
      show: false,
    },
    {
      vaccName: 'Hib B1',
      desc: 'Protects the baby from Hib virus.',
      show: false,
    },
  ],
  '18-months': [
    {
      vaccName: 'Hep-A 2',
      desc: 'Provides protection to the baby from Hepatitis A disease.',
      show: true,
    },
  ],
  '2-years': [
    {
      vaccName: 'Booster of Typhoid Conjugate Vaccine',
      desc: 'Protects the baby from the typhoid fever. The fever from the disease is quite to be serious for, as it generally gets the baby into an acute illness.',
      show: true,
    },
  ],
  '4-6-years': [
    {
      vaccName: 'DTP B2',
      desc: 'Provides the baby with the protection against three diseases – pertussis, diphtheria and tetanus.',
      show: true,
    },
    {
      vaccName: 'OPV 3',
      desc: 'Helps the baby to fight against Polio (causing paralysis).',
      show: false,
    },
    {
      vaccName: 'Varicella 2',
      desc: 'A.k.a chickenpox vaccine, and protects against the same. 1 dose prevents about 95% of the moderate diseases and 100% of the severe ones.',
      show: false,
    },
    {
      vaccName: 'MMR 3',
      desc: 'Provides immunity against rubella, measles and mumps.',
      show: false,
    },
  ],
  '10-12-years': [
    {
      vaccName: 'HPV',
      desc: 'Protects against a common virus that can cause vaginal, vulvar, cervical, anal and throat cancer.',
      show: true,
    },
  ],
};
